import { forwardRef } from 'react';
// icons
import { Icon, IconifyIcon } from '@iconify/react';
// @mui
import { Box, BoxProps, SxProps } from '@mui/material';
//

// ----------------------------------------------------------------------

export type IconifyProps = IconifyIcon | string;
interface Props extends BoxProps {
  sx?: SxProps;
  icon: IconifyIcon | string;
}

interface Props extends BoxProps {
  icon: IconifyProps;
}

const Iconify = forwardRef<SVGElement, Props>(({ icon, width = 20, sx, ...other }, ref) => (
  <Box
    ref={ref}
    component={Icon}
    icon={icon}
    sx={{ width: width, height: width, ...sx }}
    {...other}
  />
));

export default Iconify;
